(() => {
 let timer;
 const notify = (data) => {
  const toast = document.getElementById('bym-cart-toast');
  toast.textContent = `${data.product_title || data.title || 'Item'} added to cart.`;
  toast.hidden = false; clearTimeout(timer); timer=setTimeout(()=>toast.hidden=true,4000);
 };
 document.addEventListener('bym:added',event=>notify(event.detail));
 document.addEventListener('submit',async event=>{
  const form=event.target.closest('.bym-product__form'); if(!form)return;
  event.preventDefault(); const button=form.querySelector('button'); if(button.disabled)return;button.disabled=true;
  try {
   const data=new FormData(form); data.append('sections','cart-drawer,cart-icon-bubble');data.append('sections_url',location.pathname);
   const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',body:data});const item=await response.json();
   if(!response.ok)throw new Error(item.description || 'Could not add this item.');
   const drawer=document.querySelector('cart-drawer');if(drawer){drawer.classList.remove('is-empty');drawer.renderContents(item);}else notify(item);
  } catch(error){notify({title:error.message});document.getElementById('bym-cart-toast').textContent=error.message;}
  finally{button.disabled=false;}
 });
})();
